import { render, staticRenderFns } from "./ExternalPaymentApproval.vue?vue&type=template&id=03f6a54e&"
import script from "./ExternalPaymentApproval.vue?vue&type=script&lang=js&"
export * from "./ExternalPaymentApproval.vue?vue&type=script&lang=js&"
import style0 from "./ExternalPaymentApproval.vue?vue&type=style&index=0&id=03f6a54e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports